module.exports = __webpack_public_path__ + "static/scale-model-of-arlington-texas-46025f90b84b4fc5104e967bbb300f12.png";